import { render, staticRenderFns } from "./AttendancePanel.vue?vue&type=template&id=511bd62e&scoped=true"
import script from "./AttendancePanel.vue?vue&type=script&lang=js"
export * from "./AttendancePanel.vue?vue&type=script&lang=js"
import style0 from "./AttendancePanel.vue?vue&type=style&index=0&id=511bd62e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511bd62e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDialog,VFlex,VForm,VLayout,VSelect,VSwitch,VTextField})
